import { render } from "./BlocksFriendsSelector.vue?vue&type=template&id=ea26267a&scoped=true"
import script from "./BlocksFriendsSelector.vue?vue&type=script&lang=js"
export * from "./BlocksFriendsSelector.vue?vue&type=script&lang=js"

import "./BlocksFriendsSelector.vue?vue&type=style&index=0&id=ea26267a&scoped=true&lang=scss"

import exportComponent from "/builds/dobro/amway-calculator-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea26267a"]])

export default __exports__